import React, {useCallback} from 'react'
import {useForm} from 'react-hook-form'
import styled from 'styled-components'
import {Paragraph, Input, Button} from 'common/components'
import {reduxUpdateDispatcher} from 'lib/redux'
import {requestData} from 'services'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  box-sizing: border-box;
  padding: 40px;
  gap: 20px;
`

const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export default function AuthLoginForm() {
  const form = useForm<{code: string}>({defaultValues: {code: ''}})

  const handleLogin = useCallback(() => {
    const {code} = form.getValues()

    requestData('auth_login', {
      data: {code},
      onRequestSuccess: ({status, data}) => {
        if (status === 200) {
          const {token, uploader_name, tree} = data

          reduxUpdateDispatcher('user', {token, creator: uploader_name, tree})
        }
      },
    })
  }, [form])

  return (
    <StyledContainer>
      <StyledTitleContainer>
        <Paragraph fontSize="xl" fontWeight="bold" color="black_1">
          Creator Access
        </Paragraph>
        <Paragraph fontSize="m" color="gray_5">
          Upload your content with ease.
        </Paragraph>
      </StyledTitleContainer>
      <Input
        name="code"
        form={form}
        label="Code"
        rightIcon="delete"
        placeholder="Input your code"
      />
      <Button label="Open Dashboard" onClick={handleLogin} />
    </StyledContainer>
  )
}
